import { Box, Typography } from '@mui/material';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FooterLogo } from 'src/assets/svg/footer-logo.svg';
import { getTheme } from 'src/utils/getTheme';
import { Themes } from 'src/shared/enum/Themes';

import { styles } from './styles';
import { links, linksHos } from './constants';

const { themeName } = getTheme();

export const Footer: FC = () => {
    const { t } = useTranslation();
    const isHosTheme = themeName === Themes.HOUSE_OF_SOCIAL;
    const footerLinks = isHosTheme ? linksHos : links;

    const renderLinks = () =>
        footerLinks.map(({ labelLocale, to }, i) => (
            <Fragment key={labelLocale}>
                <a href={to} rel="noreferrer noopener" target="_blank" css={styles.link}>
                    <Typography variant={isHosTheme ? 'subtitle2' : 'subtitle1'}>
                        {t(labelLocale)}
                    </Typography>
                </a>
                {i !== footerLinks.length - 1 && (
                    <Typography
                        variant={isHosTheme ? 'subtitle2' : 'subtitle1'}
                        css={isHosTheme && styles.slash}
                    >
                        &#47;
                    </Typography>
                )}
            </Fragment>
        ));

    return (
        <Box css={styles.container}>
            {!isHosTheme && (
                <Box css={styles.leftSide}>
                    <FooterLogo />
                    <Typography variant="body2">{t('layout_footer_copyright')}</Typography>
                </Box>
            )}
            <Box css={isHosTheme ? styles.rightSideHos : styles.rightSide}>{renderLinks()}</Box>
        </Box>
    );
};
